"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _loader = _interopRequireDefault(require("./loader.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Loader = function Loader(_ref) {
  var _classNames, _classNames2, _classNames3;

  var bubbleClassName = _ref.bubbleClassName,
      containerProps = _ref.containerProps,
      small = _ref.small;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: _loader["default"].container
  }, containerProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_loader["default"].dot, (_classNames = {}, _classNames[_loader["default"].small] = small, _classNames), bubbleClassName)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_loader["default"].dot, (_classNames2 = {}, _classNames2[_loader["default"].small] = small, _classNames2), bubbleClassName)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_loader["default"].dot, (_classNames3 = {}, _classNames3[_loader["default"].small] = small, _classNames3), bubbleClassName)
  }));
};

Loader.defaultProps = {
  bubbleClassName: 'forum-text-background-color',
  small: false
};
var _default = Loader;
exports["default"] = _default;